import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { MedicinesService } from '@services/medicines.service';
import { InstitutionService } from '@services/institution.service';
import { CallsService } from '@services/api/calls.service';

import { FormFieldComponent } from '@shared/form-field/form-field.component';

import { MedicineEdit, MedicineOption } from '@interfaces/medicine/medicine.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-replacement',
  templateUrl: './replacement.component.html'
})
export class ReplacementComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild("medicina") medicina: FormFieldComponent;

  public form: FormGroup = new FormGroup({});

  public medicinesOptions: MedicineOption[] = [];
  medicine: MedicineEdit | undefined;

  medicineOptionsRequest: Subscription;

  subs: { [key: string]: Subscription } = {};

  public loadingMedicineData: boolean = false;
  public loadingReplacementMedicineData: boolean = false;
  public replacingMedicine: boolean = false;
  public cancelingReplacement: boolean = false;

  currentMedicine: MedicineEdit;
  replacementMedicine: MedicineEdit | undefined;

  constructor( 
    private medicinesService: MedicinesService, 
    private institutionService: InstitutionService,
    private calls: CallsService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.form.addControl('medicineInput', new FormControl(null, { validators: [] }));

    this.subs['currentMedicine'] = this.medicinesService.currentMedicine.subscribe((medicine: MedicineEdit) => {
      this.currentMedicine = medicine;

      this.getReplacementMedicine();
    });
  }

  ngOnDestroy(): void {
    Object.values(this.subs).forEach(s => s.unsubscribe());
  }
  
  ngAfterViewInit() {
    this.initializeAutocomplete();

    this.subs['medicineInput'] = this.form.controls['medicineInput'].valueChanges.subscribe((val) => {
      if ( val ) {
        this.loadingMedicineData = true;
        this.medicinesService.getMedicineByID(Number(val.id)).subscribe({
          next: (medicine: MedicineEdit) => {
            this.medicine = medicine;
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
            this.loadingMedicineData = false;
          }
        })
      }
    });
  }

  initializeAutocomplete() {
    this.cdRef.detectChanges();

    if ( this.subs['autocomplete'] ) {
      this.subs['autocomplete'].unsubscribe();
    }

    this.subs['autocomplete'] = this.medicina?.autocompleteControl?.valueChanges.subscribe((val) => {
      if ( val.trim().length >= 3 ) {
        // Cancel previous request
        if ( this.medicineOptionsRequest ) {
            this.medicineOptionsRequest.unsubscribe();
        }

        // Get medicine options
        this.medicineOptionsRequest = this.medicinesService.getMedicinesOptions(
          this.institutionService.getCurrentInstitution(),
          val
        ).subscribe((allMedicineOptions: MedicineOption[]) => {
          this.medicinesOptions = allMedicineOptions;
        });
      }
    });
  }

  getReplacementMedicine() {
    if ( this.currentMedicine.med.Sustituto ) {
      this.loadingReplacementMedicineData = true;
      this.medicinesService.getMedicineByID(Number(this.currentMedicine.med.Sustituto.Id)).subscribe({
        next: (medicine: MedicineEdit) => {
          this.replacementMedicine = medicine;
        },
        error: (error) => {
          this.calls.openSnack('Error al obtener el medicamento sustituto');
          this.loadingReplacementMedicineData = false;
          this.initializeAutocomplete();
        },
        complete: () => {
          this.loadingReplacementMedicineData = false;
          this.initializeAutocomplete();
        }
      })
    }
  }

  replaceMedicine() {
    if ( !this.medicine ) return;

    this.replacingMedicine = true;

    this.medicinesService.replaceMedicine(this.currentMedicine.med.id, this.medicine.med.id, true).subscribe({
      next: (data) => {
        this.currentMedicine.med.Sustituto = {
          Id: this.medicine!.med.id,
          CN: this.medicine!.med.did,
          Name: this.medicine!.med.nam
        };
        this.medicine = undefined;
        this.replacementMedicine = undefined;
        this.form.reset();
        this.getReplacementMedicine();
      },
      error: () => {
        this.calls.openSnack('Error al reemplazar el medicamento');
        this.replacingMedicine = false;
      },
      complete: () => {
        this.replacingMedicine = false;
      }
    });
  }

  cancelReplacement() {
    this.cancelingReplacement = true;

    this.medicinesService.replaceMedicine(this.currentMedicine.med.id, null, true).subscribe({
      next: (data) => {
        this.currentMedicine.med.Sustituto = null;
        this.medicine = undefined;
        this.replacementMedicine = undefined;
        this.form.reset();
      },
      error: () => {
        this.calls.openSnack('Error al reemplazar el medicamento');
        this.cancelingReplacement = false;
      },
      complete: () => {
        this.cancelingReplacement = false;
      }
    });
  }
}
